<template>
  <div
    v-if="orderDetails.orderType !== 'group'"
    class="cf-flex cf-flex--row cf-flex--align-center cf-flex--justify-space-between"
  >
    <div class="cf-flex cf-flex--row cf-flex--align-center cf-flex--gap-12">
      <h3 class="cf-title cf-title--3">
        {{ content.OrderSummary.metadata.orderSummary }}
      </h3>

      <!-- Reset Order Button -->
      <button
        v-if="orderDetails.orderType !== 'group'"
        class="cf-link cf-link--red cf-link--heavy"
        type="button"
        @click="resetOrderClickHandler"
      >
        Reset
      </button>
    </div>

    <button
      class="cf-button cf-button--tertiary cf-button--xs cf-button--fit-content"
      type="button"
      @click="addItemsClickHandler"
    >
      <span class="cf-icon far fa-plus" />

      Add Items
    </button>
  </div>

  <div
    v-else-if="orderDetails.orderType === 'group'"
    class="cf-flex cf-flex--column cf-flex--gap-12"
  >
    <h3 class="cf-title cf-title--3">
      Group Order
    </h3>

    <div
      v-if="isGroupOrderLocked && order.groupOrder.you.isHost"
      class="cf-flex cf-flex--column cf-flex--gap-8"
    >
      <div class="cf-flex cf-flex--row cf-flex--align-center cf-flex--justify-center cf-flex--gap-10 cf-alt-background">
        <span class="cf-icon cf-icon--red far fa-exclamation-circle" />

        <p class="cf-subtitle cf-subtitle--2 cf-subtitle--heavy">
          Your order is currently locked! Unlock to edit your order items.
        </p>
      </div>

      <button
        type="button"
        :class="['cf-button cf-button--danger cf-button--smedium cf-button--fill', {'cf-button--loading': isUnlockingGroupOrder }]"
        @click="unlockGroupOrderClickHander"
      >
        Unlock
      </button>
    </div>
  </div>
</template>


<script>
  import { mapGetters } from 'vuex';

  import errorHandlers from '@/services/error-handlers';
  import events from '@/services/events';


  export default {
    name: 'OrderItemsSummaryTitle',

    data() {
      return {
        isUnlockingGroupOrder: false
      };
    },

    computed: {
      ...mapGetters('content', ['content']),
      ...mapGetters('orders', ['order']),
      ...mapGetters('session', ['orderDetails']),

      isGroupOrderLocked() {
        return this.order.groupOrder.isLocked;
      }
    },

    methods: {
      resetOrderClickHandler() {
        this.$openModal('confirmation', {
          title: 'Reset Order',
          hideSecondaryCta: true,
          primaryText: 'Warning! You are about to reset your order and remove everything from your cart.',
          ctaConfirmText: 'Confirm',
          onConfirm: () => this.$store.dispatch('orders/cancelOrder')
        });
      },

      async unlockGroupOrderClickHander() {
        try {
          this.isUnlockingGroupOrder = true;

          await this.$store.dispatch('orders/groupOrderUpdateLock', { isLocked: false });

          events.emit('notification', {
            type: 'success',
            message: 'Your group order has been unlocked.'
          });
        }
        catch (error) {
          errorHandlers.generic(error);
        }
        finally {
          this.isUnlockingGroupOrder = false;
        }
      },

      addItemsClickHandler() {
        this.$router.push({
          name: 'orderMenu',
          params: {
            merchantId: this.$route.params.merchantId
          }
        });
      }
    }
  };
</script>
